//replaces legend.html
import classNames from "classnames";
import GAVerifiedContainer from "app/components/React/GAVerifiedIcon/GAVerifiedContainer";
import { MarkerInnerWrapper } from "./styledComponents";

export const LegendV2 = (props) => {
    const { legendItems, toggleSeries, loadingData, legendContainerClass, getIcon, colors } = props;

    return (
        <div className={`legend ${legendContainerClass}`}>
            {legendItems?.map((item, index) => {
                const iconItem = getIcon(item);
                return (
                    <div
                        key={index}
                        onClick={() => toggleSeries(item)}
                        className={classNames(
                            "legend-item",
                            { "legend-item--off": !!item.hidden || loadingData },
                            { "legend-item--disabled": item.alwaysDisabled },
                            { "legend-smallHeight": item.smallIcon },
                            item.legendClass,
                        )}
                    >
                        {iconItem ? (
                            <span
                                className="item-img"
                                title={item.name || item.Title}
                            >
                                <img
                                    className={classNames("item-icon", {
                                        "website-small-icon": item.smallIcon,
                                    })}
                                    id={item.id}
                                    crossOrigin="anonymous"
                                    src={iconItem}
                                />
                            </span>
                        ) : null}
                        <span
                            className={classNames("item-name", {
                                "item-name-no-image": !iconItem,
                                "item-reverse-ellipsis": item.reverseEllipsis,
                            })}
                            title={item.name || item.Title}
                        >
                            {item.name || item.Title}
                        </span>
                        {legendItems.length > 1 ? (
                            <span
                                className={classNames("item-marker", {
                                    "item-marker-app": iconItem,
                                    "item-marker-no-image": !iconItem,
                                })}
                                title={item.name || item.Title}
                            >
                                <span className="marker-outer">
                                    <MarkerInnerWrapper
                                        className="marker-inner"
                                        color={item.color || item.Color || colors[index]}
                                    />
                                </span>
                            </span>
                        ) : null}
                        {item.isGAVerified ? (
                            <GAVerifiedContainer
                                size="SMALL"
                                isActive={true}
                                isPrivate={item.isGAPrivate}
                                tooltipAvailable={true}
                                tooltipIsActive={false}
                                metric={""}
                            />
                        ) : null}
                    </div>
                );
            })}
        </div>
    );
};
